import { configurationForToken } from "../CommonConstants";
import apiClient from "./apiClient";

const sendMessage = (requirementId, text, token) =>
  apiClient.post(
    "/application/message/create",
    {
      requirement_id: requirementId, 
      text
    },
    configurationForToken(token)
  );

const readMessage = (requirementId, token) =>
  apiClient.post(
    "/application/message/edit",
    {
      requirementId
    },
    configurationForToken(token)
  );

const allMessages = (requirementId, token) => {
  return apiClient.get(
    `/admin/requirement/${requirementId}/messages`, 
    configurationForToken(token));
};

export default {
  sendMessage,
  readMessage,
  allMessages,
};



// WEBPACK FOOTER //
// ./src/Services/MessageService.js